<!-- 问答管理列表 -->
<template>
  <div>
    <el-row>
      <el-col :span="24">
        <Head>
          <template v-slot:title>
            <span style="margin-left: 30%">问答管理</span>
          </template>
        </Head>
      </el-col>
    </el-row>

    <el-row class="zw_nav">
      <el-col>
        <div class="grid-content bg-purple-dark nav-box">
          <ul class="nav clearfix">
            <li :class="{ active: isActive == '0' }" @click="show('0', '#1A80FC')">
              人才端
            </li>
            <li :class="{ active: isActive == '1' }" @click="show('1', '#79E46E')">
              企业端
            </li>
          </ul>
        </div>
      </el-col>
    </el-row>

    <el-row v-show="isActive == 0" class="row-top" type="flex" justify="center">
      <el-col :span="15">
        <Enterpriseside v-if="isShow"></Enterpriseside>
      </el-col>
    </el-row>

    <!-- 企业端 -->
    <el-row v-show="isActive == 1" class="row-top" type="flex" justify="center">
      <el-col :span="15">
        <Talentside v-if="isShow"></Talentside>
      </el-col>
    </el-row>

  </div>
</template>
<script>
import Head from "@/components/header/head.vue";
import Enterpriseside from "@/views/answers/component/Enterpriseside"
import Talentside from "@/views/answers/component/Talentside";
import login from "@/views/login/login";
// import grbdXq from '@/views/article/';
export default {
  name: "sensitiveWord",
  components: {
    Head,
    Enterpriseside,
    Talentside
  },
  data() {
    return {
      isShow: true,
      isActive: "0",
    };
  },
  created(){
    if(this.$route.params.isActive){
      this.isActive=this.$route.params.isActive
    }
  },
  methods: {
    show(index, color) {
      this.isActive = index;
    },
  },

};
</script>
<style lang="less" scoped>
.zw_nav {
  // height:110px;
  //padding: 0 22px;

  .nav-box {
    // background-color:yellow;
    background-color: #ffffff;
    height: 70px;
    //margin-top: 15px;
    //margin-bottom: 15px;
  }

  .nav {
    padding: 0px 0 0 315px;

    > li {
      line-height: 46px;
      width: 128px;
      //height: 46px;
      background: #eef2fb;
      box-shadow: 0px 0px 32px 6px rgba(141, 141, 141, 0.11);
      border-radius: 8px;
      float: left;
      text-align: center;
      cursor: pointer;
      font-size: 16px;
      font-weight: 400;
      color: #868ea7;
      margin-right: 50px;
    }

    li.active {
      background: #ffffff;
      color: #1a80fc;
    }
  }
}
</style>



